import { gql } from '@apollo/client';
import { RecommendedForPromotionEnum, User, UserGoal } from 'types';

export const UPDATE_USER_GOALS_MUTATION = gql`
  mutation UpdateUserGoals($input: [UpdateUserGoalsInput!]!) {
    updateUserGoals(input: $input) {
      _id
      kpi
      kra
      target
      weightage
      empCommentMidYear
      managerCommentMidYear
      user {
        _id
      }
    }
  }
`;

export type UpdateUserGoalsResponse = {
  updateUserGoals: UserGoal[];
};

export type UpdateUserGoalsVariables = {
  input: [
    {
      _id?: string;
      kpi?: string;
      kra?: string;
      user: string;
      weightage?: number;
      target?: string;
    },
  ];
};

export const DELETE_USER_GOALS_MUTATION = gql`
  mutation DeleteUserGoals($id: ID!, $userId: ID) {
    deleteUserGoals(_id: $id, userId: $userId) {
      message
      success
    }
  }
`;

export type DeleteUserGoalsResponse = {
  deleteUserGoals: {
    message: string;
    success: string;
  };
};

export type DeleteUserGoalsVariables = {
  id: string;
  userId: string;
};

export type SubmitUserGoalsReponse = {
  submitUserGoals: {
    userGoals: UserGoal[];
    user: User;
  };
};

export type SubmitUserGoalsVariables = {
  input: {
    _id?: string;
    kpi?: string;
    kra?: string;
    user: string;
    weightage?: number;
    target?: string;
  }[];
};

export const REJECT_USER_GOALS_MUTATION = gql`
  mutation RejectStartYearUserGoals($user: ID!, $remarks: String!) {
    rejectStartYearUserGoals(user: $user, remarks: $remarks) {
      _id
      annualUserInfo {
        startYearStatus
      }
    }
  }
`;

export type RejectUserGoalsResponse = {
  rejectStartYearUserGoals: User;
};

export type RejectUserGoalsVariables = {
  user: string;
  remarks: string;
};

export const REJECT_MID_YEAR_REVIEW = gql`
  mutation RejectMidYearUserGoals($userId: ID!, $remarks: String!) {
    rejectMidYearUserGoals(userId: $userId, remarks: $remarks) {
      _id
      annualUserInfo {
        midYearStatus
      }
    }
  }
`;

export type RejectMidYearReviewsResponse = {
  rejectMidYearUserGoals: User;
};

export type RejectMidYearReviewsVariables = {
  userId: string;
  remarks: string;
};

export const REJECT_END_YEAR_REVIEW = gql`
  mutation RejectEndYearUserGoals($userId: ID!, $remarks: String!) {
    rejectEndYearUserGoals(userId: $userId, remarks: $remarks) {
      _id
      annualUserInfo {
        endYearStatus
      }
    }
  }
`;

export type RejectENdYearReviewsResponse = {
  rejectMidYearUserGoals: User;
};

export type RejectEndYearReviewsVariables = {
  userId: string;
  remarks: string;
};

export const APPROVED_USER_GOALS_MUTATION = gql`
  mutation ApprovedStartYearUserGoals($userId: ID!, $remarks: String) {
    approvedStartYearUserGoals(userId: $userId, remarks: $remarks) {
      user {
        _id
        annualUserInfo {
          startYearStatus
        }
      }
    }
  }
`;

export type ApprovedUserGoalsResponse = {
  approvedStartYearUserGoals: {
    userGoals: UserGoal[];
    user: User;
  };
};

export type ApprovedUserGoalsVariables = {
  userId: string;
  remarks?: string;
};

export const APPROVE_MID_YEAR_REVIEWS = gql`
  mutation ApprovedMidYearUserGoals($userId: ID!, $remarks: String) {
    approvedMidYearUserGoals(userId: $userId, remarks: $remarks) {
      user {
        _id
        annualUserInfo {
          midYearStatus
        }
      }
    }
  }
`;

export type ApproveMidYearReviewsResponse = {
  approvedMidYearUserGoals: {
    userGoals: UserGoal[];
    user: User;
  };
};

export type ApproveMidYearReviewsVariables = {
  userId: string;
  remarks?: string;
};

export const APPROVE_END_YEAR_REVIEWS = gql`
  mutation ApprovedEndYearUserGoals($userId: ID!, $remarks: String) {
    approvedEndYearUserGoals(userId: $userId, remarks: $remarks) {
      user {
        _id
        annualUserInfo {
          endYearStatus
        }
      }
    }
  }
`;

export type ApproveEndYearReviewsResponse = {
  approvedEndYearUserGoals: {
    userGoals: UserGoal[];
    user: User;
  };
};

export type ApproveEndYearReviewsVariables = {
  userId: string;
  remarks?: string;
};

export const DOWNLOAD_END_YEAR_USER_REPORT = gql`
  query DownloadEndYearEvaluationReports($users: [ID!]!, $year: Int) {
    downloadEndYearEvaluationReports(users: $users, year: $year) {
      file
      fileName
    }
  }
`;

export type DownloadEndYearEvaluationReportVariables = {
  users: string[];
  year?: number;
};

export type DownloadEndYearEvaluationReportResponse = {
  downloadEndYearEvaluationReports: {
    file: string;
    fileName: string;
  };
};

export const DOWNLOAD_MID_YEAR_USER_REPORT = gql`
  query DownloadMidYearEvaluationReports($users: [ID!]!, $year: Int) {
    downloadMidYearEvaluationReports(users: $users, year: $year) {
      file
      fileName
    }
  }
`;

export type DownloadMidYearEvaluationReportVariables = {
  users: string[];
  year?: number;
};

export type DownloadMidYearEvaluationReportResponse = {
  downloadMidYearEvaluationReports: {
    file: string;
    fileName: string;
  };
};

export const SAVE_START_YR_USER_GOALS = gql`
  mutation UpdateStartYearUserGoals($input: [UpdateUserGoalsInput!]!) {
    updateStartYearUserGoals(input: $input) {
      _id
      kpi
      kra
      target
      weightage
      user {
        _id
        annualUserInfo {
          startYearStatus
        }
      }
    }
  }
`;

export type SaveStartYrUserGoalsResponse = {
  updateStartYearUserGoals: UserGoal[];
};

export type SaveStartYrUserGoalsVariables = {
  input: [
    {
      _id?: string;
      kpi?: string;
      kra?: string;
      user: string;
      weightage?: number;
      target?: string;
    },
  ];
};

export const SUBMIT_START_YR_USERS_GOALS = gql`
  mutation SubmitStartYearUserGoals($input: [SubmitUserGoalsInput!]!) {
    submitStartYearUserGoals(input: $input) {
      userGoals {
        _id
        kpi
        kra
        target
        weightage
      }
      user {
        _id
        annualUserInfo {
          startYearStatus
        }
      }
    }
  }
`;

export type SubmitStartYrUserGoalsReponse = {
  submitStartYearUserGoals: {
    userGoals: UserGoal[];
    user: User;
  };
};

export type SubmitStartYrUserGoalsVariables = {
  input: {
    _id?: string;
    kpi?: string;
    kra?: string;
    user: string;
    weightage?: number;
    target?: string;
  }[];
};

export const UPDATE_MID_YEAR_REVIEW = gql`
  mutation UpdateMidYearUserGoals($input: [UpdateMidYearUserGoalsInput!]!) {
    updateMidYearUserGoals(input: $input) {
      _id
      kra
      kpi
      weightage
      target
      empCommentMidYear
      managerCommentMidYear
      user {
        _id
        annualUserInfo {
          midYearStatus
        }
      }
    }
  }
`;

export type UpdateMidYearReviewResponse = {
  updateMidYearUserGoals: UserGoal[];
};

export type UpdateMidYearReviewVariables = {
  input: {
    userId: string;
    userGoalId: string;
    empCommentMidYear?: string;
    managerCommentMidYear?: string;
  }[];
};

export const SUBMIT_MID_YEAR_REVIEW = gql`
  mutation SubmitMidYearUserGoals($input: [SubmitMidYearUserGoalsInput!]!) {
    submitMidYearUserGoals(input: $input) {
      userGoals {
        _id
        kra
        kpi
        weightage
        target
        empCommentMidYear
        managerCommentMidYear
      }
      user {
        _id
        annualUserInfo {
          midYearStatus
        }
      }
    }
  }
`;

export type SubmitMidYearReviewResponse = {
  submitMidYearUserGoals: {
    userGoals: UserGoal[];
    user: User;
  };
};

export type SubmitMidYearReviewVariables = {
  input: {
    userId: string;
    userGoalId: string;
    empCommentMidYear: string;
    managerCommentMidYear: string;
  }[];
};

export const UPDATE_END_YEAR_REVIEW = gql`
  mutation UpdateEndYearUserGoals($input: UpdateEndYearUserGoalsAndUserInput) {
    updateEndYearUserGoals(input: $input) {
      userGoals {
        _id
        kra
        kpi
        weightage
        target
        empCommentMidYear
        managerCommentMidYear
        empCommentEndYear
        empRatingEndYear
        managerCommentEndYear
        managerRatingEndYear
      }
      user {
        _id
        annualUserInfo {
          startYearStatus
          midYearStatus
          endYearStatus
          overallCommentByManager
          overallCommentByEmployee
        }
      }
    }
  }
`;

export type UpdateEndYearReviewResponse = {
  updateEndYearUserGoals: {
    userGoals: UserGoal[];
    user: User;
  };
};

export type UpdateEndYearReviewVariables = {
  input: {
    userGoals: {
      userId: string;
      userGoalId: string;
      empCommentEndYear?: string;
      managerCommentEndYear?: string;
      empRatingEndYear?: string;
      managerRatingEndYear?: string;
    }[];
    overallCommentByEmployee?: string;
    overallCommentByManager?: string;
    isRecommendedForPromotion?: string;
    userId: string;
  };
};

export const SUBMIT_END_YEAR_REVIEW = gql`
  mutation SubmitEndYearUserGoals($input: SubmitEndYearUserGoalsAndUserInput) {
    submitEndYearUserGoals(input: $input) {
      userGoals {
        _id
        kra
        kpi
        weightage
        target
        empCommentMidYear
        managerCommentMidYear
        empCommentEndYear
        empRatingEndYear
        managerCommentEndYear
        managerRatingEndYear
      }
      user {
        _id
        annualUserInfo {
          endYearStatus
          overallRatingBySelf
        }
      }
    }
  }
`;

export type SubmitEndYearReviewResponse = {
  submitEndYearUserGoals: {
    userGoals: UserGoal[];
    user: User;
  };
};

export type SubmitEndYearReviewVariables = {
  input: {
    userGoals: {
      userId: string;
      userGoalId: string;
      empCommentEndYear?: string;
      managerCommentEndYear?: string;
      empRatingEndYear?: string;
      managerRatingEndYear?: string;
      overallCommentByEmployee?: string;
      overallCommentByManager?: string;
    }[];
    overallCommentByEmployee: string;
    overallCommentByManager?: string;
    isRecommendedForPromotion: RecommendedForPromotionEnum;
  };
};
